import { IApplicationState } from '../../../../../../types/types';

export const getMentionSubstring = (state: IApplicationState) => {
    return state.comments.mentionSubstring;
}
